<template>
  <v-container fluid>
    <v-form ref="formArchive">
      <v-row>
        <v-col cols="1">
          <v-combobox
            v-model="filter.name"
            :label="$t('label.name')"
            :items="listName"
            append-icon
            auto-select-first
            hide-details
            clearable
            dense
          />
        </v-col>
        <v-col cols="1">
          <v-combobox
            v-model="filter.surname"
            :label="$t('label.surname')"
            :items="listSurname"
            append-icon
            auto-select-first
            hide-details
            clearable
            dense
          />
        </v-col>
        <v-col cols="1">
          <v-combobox
            v-model="filter.documentType"
            :label="$tc('label.documentType')"
            :items="listDocumentType"
            append-icon
            auto-select-first
            hide-details
            clearable
            dense
          />
        </v-col>
        <v-col cols="1">
          <v-combobox
            v-model="filter.documentNo"
            :label="$t('label.documentno')"
            :items="listDocumentNo"
            append-icon
            auto-select-first
            hide-details
            clearable
            dense
          />
        </v-col>
        <v-col cols="1">
          <v-autocomplete
            v-model="filter.country"
            :label="$tc('label.country')"
            :items="listCountries"
            append-icon
            auto-select-first
            item-text="comboBoxName"
            item-value="A3"
            hide-details
            clearable
            dense
          />
        </v-col>
        <v-col cols="1">
          <v-combobox
            v-model="filter.areaName"
            :label="$tc('label.area')"
            :items="listAreaName"
            append-icon
            auto-select-first
            hide-details
            clearable
            dense
          />
        </v-col>
        <v-col cols="1">
          <v-combobox
            v-model="filter.employeeOrgID"
            :label="$t('label.visitingID')"
            :items="listEmployeeOrgID"
            append-icon
            auto-select-first
            hide-details
            clearable
            dense
          />
        </v-col>
        <v-col cols="1">
          <v-combobox
            v-model="filter.employeeName"
            :label="$t('label.visitingName')"
            :items="listEmployeeName"
            append-icon
            auto-select-first
            hide-details
            clearable
            dense
          />
        </v-col>
        <v-col cols="1">
          <v-combobox
            v-model="filter.employeeSurname"
            :label="$t('label.visitingSurname')"
            :items="listEmployeeSurname"
            append-icon
            auto-select-first
            hide-details
            clearable
            dense
          />
        </v-col>
        <v-col cols="1">
          <v-combobox
            v-model="filter.workplaceNameEnter"
            :label="$t('label.workplaceIn')"
            :items="listWorkplaceNameEnter"
            append-icon
            auto-select-first
            hide-details
            clearable
            dense
          />
        </v-col>
        <v-col cols="1">
          <v-combobox
            v-model="filter.workplaceNameExit"
            :label="$t('label.workplaceOut')"
            :items="listWorkplaceNameExit"
            append-icon
            auto-select-first
            hide-details
            clearable
            dense
          />
        </v-col>
        <v-col cols="1">
          <v-btn color="colorSearch" @click="dataLoad" block small>{{ $t('btn.search') }}</v-btn>
        </v-col>
      </v-row>
      <!--FILTRE DRUHY RIADOK------------------------------------------------------------------------------->
      <v-row>
        <v-col class="py-0" cols="2">
          <v-menu
            v-model="datePickerMenuEnterFrom"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                ref="dateText"
                v-model="dateFormattedEnterFrom"
                :label="`${$t('label.arrival')} ${$t('label.from')} (${$store.state.auth.df.date.replace('YYYY', $t('label.YYYY'))})`"
                :append-icon="mdiCalendar"
                @blur="filter.dateEnterFrom = momentParse(dateFormattedEnterFrom)"
                :rules="[ruleValidDate]"
                hide-details
                clearable
                dense
                v-on="on"
                autocomplete="off"
              />
            </template>
            <v-date-picker
              :first-day-of-week="$store.state.auth.df.firstDayOfWeek"
              v-model="filter.dateEnterFrom"
              no-title
              @input="datePickerMenuEnterFrom = false"
            />
          </v-menu>
        </v-col>
        <v-col class="py-0" cols="2">
          <v-menu
            v-model="datePickerMenuExitFrom"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                ref="dateText"
                v-model="dateFormattedExitFrom"
                :label="`${$t('label.departure')} ${$t('label.from')} (${$store.state.auth.df.date.replace('YYYY', $t('label.YYYY'))})`"
                :append-icon="mdiCalendar"
                @blur="filter.dateExitFrom = momentParse(dateFormattedExitFrom)"
                :rules="[ruleValidDate]"
                hide-details
                clearable
                dense
                v-on="on"
                autocomplete="off"
              />
            </template>
            <v-date-picker
              :first-day-of-week="$store.state.auth.df.firstDayOfWeek"
              v-model="filter.dateExitFrom"
              no-title
              @input="datePickerMenuExitFrom = false"
            />
          </v-menu>
        </v-col>
        <v-col class="py-0" cols="2">
          <v-menu
            v-model="datePickerMenuExpireFrom"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                ref="dateText"
                v-model="dateFormattedExpireFrom"
                :label="`${$t('label.expire')} ${$t('label.from')} (${$store.state.auth.df.date.replace('YYYY', $t('label.YYYY'))})`"
                :append-icon="mdiCalendar"
                @blur="filter.dateExpireFrom = momentParse(dateFormattedExpireFrom)"
                :rules="[ruleValidDate]"
                hide-details
                clearable
                dense
                v-on="on"
                autocomplete="off"
              />
            </template>
            <v-date-picker
              :first-day-of-week="$store.state.auth.df.firstDayOfWeek"
              v-model="filter.dateExpireFrom"
              no-title
              @input="datePickerMenuExpireFrom = false"
            />
          </v-menu>
        </v-col>
        <v-col class="py-0" cols="1">
          <v-combobox
            v-model="filter.companyName"
            :label="$tc('label.company') + ':'"
            :items="listCompanyName"
            append-icon
            auto-select-first
            hide-details
            clearable
            dense
          />
        </v-col>
        <v-col class="py-0" cols="1">
          <v-combobox
            v-model="filter.companyVatin"
            :label="`${$tc('label.company')} ${$t('label.vatNumber')}`"
            :items="listCompanyVatin"
            append-icon
            auto-select-first
            hide-details
            clearable
            dense
          />
        </v-col>
        <v-col class="py-0" cols="1">
          <v-combobox
            v-model="filter.carPlate"
            :label="$t('label.carPlate')"
            :items="listCarPlate"
            append-icon
            auto-select-first
            hide-details
            clearable
            dense
          />
        </v-col>
        <v-col class="py-0" cols="1">
          <v-combobox
            v-model="filter.carType"
            :label="$t('label.carType')"
            :items="listCarType"
            append-icon
            auto-select-first
            hide-details
            clearable
            dense
          />
        </v-col>
        <v-col class="py-0" cols="1">
          <v-combobox
            v-model="filter.carColor"
            :label="$t('label.carColor')"
            :items="listCarColor"
            append-icon
            auto-select-first
            hide-details
            clearable
            dense
          />
        </v-col>
        <v-col class="py-0" cols="1">
          <v-btn color="colorCancel" @click="clearFilter" block small>{{ $t('btn.cancel') }}</v-btn>
        </v-col>
      </v-row>
      <!--FILTRE TRETI RIADOK------------------------------------------------------------------------------->
      <v-row>
        <v-col class="pb-1" cols="2">
          <v-menu
            v-model="datePickerMenuEnterTo"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                ref="dateText"
                v-model="dateFormattedEnterTo"
                :label="`${$t('label.arrival')} ${$t('label.to')} (${$store.state.auth.df.date.replace('YYYY', $t('label.YYYY'))})`"
                :append-icon="mdiCalendar"
                @blur="filter.dateEnterTo = momentParse(dateFormattedEnterTo)"
                :rules="[ruleValidDate]"
                hide-details
                clearable
                dense
                v-on="on"
                autocomplete="off"
              />
            </template>
            <v-date-picker
              :first-day-of-week="$store.state.auth.df.firstDayOfWeek"
              v-model="filter.dateEnterTo"
              no-title
              @input="datePickerMenuEnterTo = false"
            />
          </v-menu>
        </v-col>
        <v-col class="pb-0" cols="2">
          <v-menu
            v-model="datePickerMenuExitTo"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                ref="dateText"
                v-model="dateFormattedExitTo"
                :label="`${$t('label.departure')} ${$t('label.to')} (${$store.state.auth.df.date.replace('YYYY', $t('label.YYYY'))})`"
                :append-icon="mdiCalendar"
                @blur="filter.dateExitTo = momentParse(dateFormattedExitTo)"
                :rules="[ruleValidDate]"
                hide-details
                clearable
                dense
                v-on="on"
                autocomplete="off"
              />
            </template>
            <v-date-picker
              :first-day-of-week="$store.state.auth.df.firstDayOfWeek"
              v-model="filter.dateExitTo"
              no-title
              @input="datePickerMenuExitTo = false"
            />
          </v-menu>
        </v-col>
        <v-col class="pb-0" cols="2">
          <v-menu
            v-model="datePickerMenuExpireTo"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                ref="dateText"
                v-model="dateFormattedExpireTo"
                :label="`${$t('label.expire')} ${$t('label.to')} (${$store.state.auth.df.date.replace('YYYY', $t('label.YYYY'))})`"
                :append-icon="mdiCalendar"
                @blur="filter.dateExpireTo = momentParse(dateFormattedExpireTo)"
                :rules="[ruleValidDate]"
                hide-details
                clearable
                dense
                v-on="on"
                autocomplete="off"
              />
            </template>
            <v-date-picker
              :first-day-of-week="$store.state.auth.df.firstDayOfWeek"
              v-model="filter.dateExpireTo"
              no-title
              @input="datePickerMenuExpireTo = false"
            />
          </v-menu>
        </v-col>
        <v-col class="pb-0" cols="1">
          <v-combobox
            v-model="filter.visitorCardIdentifier"
            :label="$tc('label.visitorcard')"
            :items="listVisitorCardIdentifier"
            append-icon
            auto-select-first
            hide-details
            clearable
            dense
          />
        </v-col>
        <v-col class="pb-0" cols="1">
          <v-combobox
            v-model="filter.usrDef1"
            :label="$store.state.auth.settings.usrDef1name ? $store.state.auth.settings.usrDef1name : 'usrDef1'"
            :items="listUsrDef1"
            append-icon
            auto-select-first
            hide-details
            clearable
            dense
          />
        </v-col>
        <v-col class="pb-0" cols="1">
          <v-combobox
            v-model="filter.usrDef2"
            :label="$store.state.auth.settings.usrDef2name ? $store.state.auth.settings.usrDef2name : 'usrDef2'"
            :items="listUsrDef2"
            append-icon
            auto-select-first
            hide-details
            clearable
            dense
          />
        </v-col>
        <v-col class="pb-0" cols="1">
          <v-combobox
            v-model="filter.usrDef3"
            :label="$store.state.auth.settings.usrDef3name ? $store.state.auth.settings.usrDef3name : 'usrDef3'"
            :items="listUsrDef3"
            append-icon
            auto-select-first
            hide-details
            clearable
            dense
          />
        </v-col>
        <v-col class="pb-0" cols="1">
          <v-combobox
            v-model="filter.usrDef4"
            :label="$store.state.auth.settings.usrDef4name ? $store.state.auth.settings.usrDef4name : 'usrDef4'"
            :items="listUsrDef4"
            append-icon
            auto-select-first
            hide-details
            clearable
            dense
          />
        </v-col>
        <v-col class="pb-0" cols="1">
          <v-btn :disabled="!$store.state.auth.userSettings.accArchive.export" color="colorExport" @click="dialogExport = true" block small>
            {{ $t('btn.export') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
    <!--TABULKA------------------------------------------------------------------------------->
    <v-row>
      <v-col class="pb-0 mb-0">
        <v-data-table
          :headers="headers"
          :loading="loading"
          :items="tableData"
          :footer-props="{ itemsPerPageOptions: [10, 20, 30, 40, 50] }"
          :options.sync="tableOptions"
          :server-items-length="totalItems"
          fixed-header
          must-sort
          dense
          :height="$store.state.windowSize.y - 240"
          class="tableCursor"
        >
          <template v-slot:item="{ item }">
            <tr @click="showTranDetail(item)">
              <td class="px-1" v-for="header in headers" v-bind:key="header.value">
                <span v-if="header.value.split('.').length < 2">
                  <span v-if="header.value == 'timeInObject'">{{ formatTimeInObject(item[header.value]) }}</span>
                  <span
                    v-else-if="
                      (header.value == 'timeenter' || header.value == 'timeexit' || header.value == 'expire') && item[header.value] != ''
                    "
                  >
                    <span v-if="header.value == 'expire'">{{ formatDate(item[header.value], $store.state.auth.df.date) }}</span>
                    <span v-else>
                      {{ formatDateTZ(item[header.value], item.timezone, $store.state.auth.df.dateYearTime) }}
                    </span>
                  </span>
                  <span v-else>{{ item[header.value] }}</span>
                </span>
                <span v-else>{{ item[header.value.split('.')[0]][header.value.split('.')[1]] }}</span>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <!--DIALOGS------------------------------------------------------------------------------->
    <v-dialog v-model="dialogPrintLoader" persistent max-width="60%">
      <v-card>
        <v-card-title class="headline colorHeadlineStandard" primary-title>
          <v-icon>{{ mdiPrinter }}</v-icon>
        </v-card-title>
        <div style="min-height: 300px" class="text-md-center">
          <div style="min-height: 80px" />
          <v-progress-circular :size="100" color="primary" indeterminate></v-progress-circular>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="exportLoader" persistent max-width="40vw">
      <v-card color="rgb(242, 242, 242, 0.6)">
        <v-card-title class="headline blue-grey lighten-3" primary-title>
          <v-icon>{{ mdiPrinter }}</v-icon>
        </v-card-title>
        <div style="min-height: 300px" class="text-md-center">
          <div style="min-height: 80px" />
          <v-progress-circular :size="160" :width="20" color="light-blue lighten-2" indeterminate></v-progress-circular>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogExport" persistent max-width="60%">
      <v-card>
        <v-card-title class="headline colorHeadlineStandard" primary-title>
          {{ $t('label.print') }}/{{ $t('label.export') }}
          <v-spacer />
          <v-icon large @click="dialogExport = false">{{ mdiClose }}</v-icon>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="8">
              <v-select
                v-model="selectedTemplate"
                :label="$tc('label.printTemplate')"
                :items="listTemplates"
                item-text="name"
                item-value="id"
                :return-object="false"
                :prepend-inner-icon="mdiPrinter"
                auto-select-first
                hide-details
              />
            </v-col>
            <v-col class="mt-2" cols="4">
              <v-btn block v-bind:disabled="listTemplates.length == 0" color="colorReport" @click="((dataExport = 'print'), dataLoad())">
                {{ $t('btn.print') }}
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="2">
              <v-btn color="colorExportFormat" @click="((dataExport = 'xlsx'), dataLoad())" block>Excel</v-btn>
            </v-col>
            <v-col cols="2">
              <v-btn color="colorExportFormat" @click="((dataExport = 'xml'), dataLoad())" block>XML</v-btn>
            </v-col>
            <v-col cols="2">
              <v-btn color="colorExportFormat" @click="((dataExport = 'csv'), dataLoad())" block>CSV</v-btn>
            </v-col>
            <v-col cols="2">
              <v-btn color="colorExportFormat" @click="((dataExport = 'json'), dataLoad())" block>JSON</v-btn>
            </v-col>
            <v-col cols="2">
              <v-btn color="colorExportFormat" @click="((dataExport = 'yaml'), dataLoad())" block>YAML</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn color="colorCancel" @click="dialogExport = false">{{ $t('btn.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ArchiveTransactionDetail
      :tranUUID="tranUUID"
      :areaName="tranAreaName"
      :dialogTranDetail="tranShowDetail"
      v-on:dialogTranDetail="tranShowDetail = false"
    />
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue';
import axios from 'axios';
import ArchiveTransactionDetail from '@/components/ArchiveTransactionDetail.vue';
import { mdiCalendar, mdiPrinter, mdiClose } from '@mdi/js';

export default Vue.extend({
  name: 'ArchiveTransactions',
  components: {
    ArchiveTransactionDetail,
  },
  data: () => ({
    mountOK: false, // Blokuje watcher pri prvom nacitani dat
    tableData: [],
    listName: [],
    listSurname: [],
    listDocumentType: [],
    listDocumentNo: [],
    listAreaName: [],
    listEmployeeOrgID: [],
    listEmployeeName: [],
    listEmployeeSurname: [],
    listWorkplaceNameEnter: [],
    listWorkplaceNameExit: [],
    listCompanyName: [],
    listCompanyVatin: [],
    listCarPlate: [],
    listCarType: [],
    listCarColor: [],
    listVisitorCardIdentifier: [],
    listUsrDef1: [],
    listUsrDef2: [],
    listUsrDef3: [],
    listUsrDef4: [],
    listCountries: [],
    listTemplates: [],
    selectedTemplate: 0,
    loading: false,
    exportLoader: false,
    dialogPrintLoader: false,
    dialogExport: false,
    filter: {
      name: '',
      surname: '',
      documentType: '',
      documentNo: '',
      dateEnterFrom: '',
      dateEnterTo: '',
      dateExitFrom: '',
      dateExitTo: '',
      workplaceNameEnter: '',
      workplaceNameExit: '',
      dateExpireFrom: '',
      dateExpireTo: '',
      country: '',
      visitorCardIdentifier: '',
      areaName: '',
      employeeOrgID: '',
      employeeName: '',
      employeeSurname: '',
      companyName: '',
      companyVatin: '',
      carPlate: '',
      carType: '',
      carColor: '',
      usrDef1: '',
      usrDef2: '',
      usrDef3: '',
      usrDef4: '',
    },
    datePickerMenuEnterFrom: false,
    datePickerMenuEnterTo: false,
    datePickerMenuExitFrom: false,
    datePickerMenuExitTo: false,
    datePickerMenuExpireFrom: false,
    datePickerMenuExpireTo: false,
    dateFormattedEnterFrom: '',
    dateFormattedEnterTo: '',
    dateFormattedExitFrom: '',
    dateFormattedExitTo: '',
    dateFormattedExpireFrom: '',
    dateFormattedExpireTo: '',
    dataExport: '', // Definuje format exportu, prazdny znamena nacitanie dat
    tableOptions: {
      sortBy: ['timeenter'],
      sortDesc: [true],
      itemsPerPage: 20,
      page: 1,
    },
    totalItems: 0,
    tranUUID: '',
    tranAreaName: '',
    tranShowDetail: false,
    mdiCalendar: mdiCalendar,
    mdiPrinter: mdiPrinter,
    mdiClose: mdiClose,
  }),
  watch: {
    tableOptions: {
      handler() {
        // Nenacitavaj ak uzivatel nema prava na archiv
        // Moze nastat ak sa uzivatel pokusi zadat link rucne
        // mountOK - pusta sa az po uspesnom vue mounted
        if (this.$store.state.auth.userSettings.accArchive.read && this.mountOK) {
          this.dataLoad();
        }
      },
      deep: true,
    },
    '$store.state.auth.settings'() {
      this.$nextTick(() => {
        for (const header of this.headers) {
          if (this.$store.state.auth.settings.usrDef1name !== '') {
            if (header.text === 'usrDef1') {
              header.text = this.$store.state.auth.settings.usrDef1name;
            }
          }
          if (this.$store.state.auth.settings.usrDef2name !== '') {
            if (header.text === 'usrDef2') {
              header.text = this.$store.state.auth.settings.usrDef2name;
            }
          }
          if (this.$store.state.auth.settings.usrDef3name !== '') {
            if (header.text === 'usrDef3') {
              header.text = this.$store.state.auth.settings.usrDef3name;
            }
          }
          if (this.$store.state.auth.settings.usrDef4name !== '') {
            if (header.text === 'usrDef4') {
              header.text = this.$store.state.auth.settings.usrDef4name;
            }
          }
        }
      });
    },
    'filter.dateEnterFrom'() {
      this.$nextTick(() => {
        var date: string = this.$moment(this.filter.dateEnterFrom).format(this.$store.state.auth.df.date);
        if (date !== 'Invalid date') {
          this.dateFormattedEnterFrom = date;
        } else {
          this.filter.dateEnterFrom = '';
          this.dateFormattedEnterFrom = '';
        }
      });
    },
    'filter.dateEnterTo'() {
      this.$nextTick(() => {
        var date: string = this.$moment(this.filter.dateEnterTo).format(this.$store.state.auth.df.date);
        if (date !== 'Invalid date') {
          this.dateFormattedEnterTo = date;
        } else {
          this.filter.dateEnterTo = '';
          this.dateFormattedEnterTo = '';
        }
      });
    },
    'filter.dateExitFrom'() {
      this.$nextTick(() => {
        var date: string = this.$moment(this.filter.dateExitFrom).format(this.$store.state.auth.df.date);
        if (date !== 'Invalid date') {
          this.dateFormattedExitFrom = date;
        } else {
          this.filter.dateExitFrom = '';
          this.dateFormattedExitFrom = '';
        }
      });
    },
    'filter.dateExitTo'() {
      this.$nextTick(() => {
        var date: string = this.$moment(this.filter.dateExitTo).format(this.$store.state.auth.df.date);
        if (date !== 'Invalid date') {
          this.dateFormattedExitTo = date;
        } else {
          this.filter.dateExitTo = '';
          this.dateFormattedExitTo = '';
        }
      });
    },
    'filter.dateExpireFrom'() {
      this.$nextTick(() => {
        var date: string = this.$moment(this.filter.dateExpireFrom).format(this.$store.state.auth.df.date);
        if (date !== 'Invalid date') {
          this.dateFormattedExpireFrom = date;
        } else {
          this.filter.dateExpireFrom = '';
          this.dateFormattedExpireFrom = '';
        }
      });
    },
    'filter.dateExpireTo'() {
      this.$nextTick(() => {
        var date: string = this.$moment(this.filter.dateExpireTo).format(this.$store.state.auth.df.date);
        if (date !== 'Invalid date') {
          this.dateFormattedExpireTo = date;
        } else {
          this.filter.dateExpireTo = '';
          this.dateFormattedExpireTo = '';
        }
      });
    },
  },
  computed: {
    headers: function () {
      return [
        { text: '', value: 'lineNumber', sortable: false, width: '1%' },
        { text: this.$i18n.t('colTran.text.name'), value: 'name', width: '140px' },
        { text: this.$i18n.t('colTran.text.surname'), value: 'surname', width: '140px' },
        { text: this.$i18n.t('colTran.text.documenttype'), value: 'documenttype', width: '100px' },
        { text: this.$i18n.t('colTran.text.documentno'), value: 'documentno', width: '140px' },
        { text: this.$i18n.t('colTran.text.timeenter'), value: 'timeenter', width: '180px' },
        { text: this.$i18n.t('colTran.text.timeexit'), value: 'timeexit', width: '180px' },
        { text: this.$i18n.t('colTran.text.timeInObject'), value: 'timeInObject', width: '120px' },
        { text: this.$i18n.t('colTran.text.expire'), value: 'expire', width: '140px' },
        { text: this.$i18n.t('colTran.text.country'), value: 'country', width: '140px' },
        { text: this.$i18n.t('colTran.text.visitorcard.identifier'), value: 'visitorcard.identifier', width: '140px' },
        { text: this.$i18n.t('colTran.text.visitorcard.note'), value: 'visitorcard.note', width: '180px' },
        { text: this.$i18n.t('colTran.text.area.name'), value: 'area.name', width: '140px' },
        { text: this.$i18n.t('colTran.text.area.note'), value: 'area.note', width: '180px' },
        { text: this.$i18n.t('colTran.name.workplaceNameEnter'), value: 'workplaceNameEnter', width: '140px' },
        { text: this.$i18n.t('colTran.name.workplaceNameExit'), value: 'workplaceNameExit', width: '140px' },
        { text: this.$i18n.t('colTran.text.employee.orgID'), value: 'employee.orgID', width: '140px' },
        { text: this.$i18n.t('colTran.text.employee.name'), value: 'employee.name', width: '140px' },
        { text: this.$i18n.t('colTran.text.employee.surname'), value: 'employee.surname', width: '140px' },
        { text: this.$i18n.t('colTran.text.employee.department'), value: 'employee.department', width: '140px' },
        { text: this.$i18n.t('colTran.text.employee.position'), value: 'employee.position', width: '140px' },
        { text: this.$i18n.t('colTran.text.employee.floor'), value: 'employee.floor', width: '140px' },
        { text: this.$i18n.t('colTran.text.employee.door'), value: 'employee.door', width: '140px' },
        { text: this.$i18n.t('colTran.text.employee.email'), value: 'employee.email', width: '140px' },
        { text: this.$i18n.t('colTran.text.employee.phone'), value: 'employee.phone', width: '140px' },
        { text: this.$i18n.t('colTran.text.employee.mobile'), value: 'employee.mobile', width: '140px' },
        { text: this.$i18n.t('colTran.text.employee.note'), value: 'employee.note', width: '140px' },
        { text: this.$i18n.t('colTran.text.company.name'), value: 'company.name', width: '140px' },
        { text: this.$i18n.t('colTran.text.company.vatin'), value: 'company.vatin', width: '140px' },
        { text: this.$i18n.t('colTran.text.company.address'), value: 'company.address', width: '160px' },
        { text: this.$i18n.t('colTran.text.car.plate'), value: 'car.plate', width: '140px' },
        { text: this.$i18n.t('colTran.text.car.state'), value: 'car.state', width: '140px' },
        { text: this.$i18n.t('colTran.text.car.type'), value: 'car.type', width: '140px' },
        { text: this.$i18n.t('colTran.text.car.color'), value: 'car.color', width: '140px' },
        { text: this.$i18n.t('colTran.text.entryType'), value: 'entryType', width: '140px' },
        { text: 'usrDef1', value: 'usrDef1', width: '180px' },
        { text: 'usrDef2', value: 'usrDef2', width: '180px' },
        { text: 'usrDef3', value: 'usrDef3', width: '180px' },
        { text: 'usrDef4', value: 'usrDef4', width: '180px' },
        { text: this.$i18n.t('colTran.text.note'), value: 'note', width: '400px' },
        { text: this.$i18n.t('colTran.text.notify'), value: 'notify', width: '180px' },
        { text: this.$i18n.t('colTran.text.pbOrgID'), value: 'pbOrgID', width: '140px' },
        { text: this.$i18n.t('colTran.text.pbName'), value: 'pbName', width: '140px' },
        { text: this.$i18n.t('colTran.text.pbSurname'), value: 'pbSurname', width: '140px' },
        { text: this.$i18n.t('colTran.text.abOrgID'), value: 'abOrgID', width: '140px' },
        { text: this.$i18n.t('colTran.text.abName'), value: 'abName', width: '140px' },
        { text: this.$i18n.t('colTran.text.abSurname'), value: 'abSurname', width: '140px' },
      ];
    },
    ruleValidDate() {
      return (v: any) =>
        v == null || v == '' || this.$moment(v, this.$store.state.auth.df.date, true).isValid() || this.$i18n.t('msg.invalidDateFormat');
    },
  },
  mounted() {
    if (!this.$store.state.auth.userSettings.accArchive.read) {
      this.$router.push('/norights');
      return;
    }
    var date = new Date();
    date.setDate(new Date().getDate() - 90);
    this.filter.dateEnterFrom = date.toISOString();
    this.dataLoad().then(() => {
      this.loadListCountries();
      this.loadListbox('name');
      this.loadListbox('surname');
      this.loadListbox('documentType');
      this.loadListbox('documentNo');
      this.loadListbox('areaName');
      this.loadListbox('employeeOrgID');
      this.loadListbox('employeeName');
      this.loadListbox('employeeSurname');
      this.loadListbox('workplaceNameEnter');
      this.loadListbox('workplaceNameExit');
      this.loadListbox('companyName');
      this.loadListbox('companyVatin');
      this.loadListbox('carPlate');
      this.loadListbox('carType');
      this.loadListbox('carColor');
      this.loadListbox('visitorCardIdentifier');
      this.loadListbox('usrDef1');
      this.loadListbox('usrDef2');
      this.loadListbox('usrDef3');
      this.loadListbox('usrDef4');
      this.loadListTemplates();
      this.$nextTick(() => {
        // Povol nacitanie z watcher az ked je vsetko nacitane
        this.mountOK = true;
      });
    });
  },
  methods: {
    showTranDetail(tran: any) {
      if (tran.iwpMandatory < 1) {
        return;
      }
      this.tranUUID = tran.uuid;
      this.tranAreaName = tran.area.name;
      this.tranShowDetail = true;
    },
    async dataLoad() {
      const form: any = this.$refs.formArchive;
      if (!form.validate()) {
        return;
      }
      switch (this.dataExport) {
        case 'xlsx': {
          this.callData('/api/v1/archive-export', 'blob');
          this.exportLoader = true;
          break;
        }
        case 'xml': {
          this.callData('/api/v1/archive-export', 'blob');
          this.exportLoader = true;
          break;
        }
        case 'csv': {
          this.callData('/api/v1/archive-export', 'blob');
          this.exportLoader = true;
          break;
        }
        case 'yaml': {
          this.callData('/api/v1/archive-export', 'blob');
          this.exportLoader = true;
          break;
        }
        case 'json': {
          this.callData('/api/v1/archive-export', 'blob');
          this.exportLoader = true;
          break;
        }
        case 'print': {
          this.callData('/api/v1/archive-export', 'text');
          this.exportLoader = true;
          break;
        }
        default: {
          this.callData('/api/v1/archive', 'json');
          this.loading = true;
          break;
        }
      }
    },
    async callData(sourceAddress: string, responseTypeDef: any) {
      this.loading = true;
      await axios
        .get(sourceAddress, {
          params: {
            sortBy: this.tableOptions.sortBy[0],
            descending: this.tableOptions.sortDesc[0],
            rowsPerPage: this.tableOptions.itemsPerPage,
            page: this.tableOptions.page,
            name: this.filter.name,
            surname: this.filter.surname,
            documentType: this.filter.documentType,
            documentNo: this.filter.documentNo,
            dateEnterFrom: this.filter.dateEnterFrom,
            dateEnterTo: this.filter.dateEnterTo,
            dateExitFrom: this.filter.dateExitFrom,
            dateExitTo: this.filter.dateExitTo,
            wpEnter: this.filter.workplaceNameEnter,
            wpExit: this.filter.workplaceNameExit,
            dateExpireFrom: this.filter.dateExpireFrom,
            dateExpireTo: this.filter.dateExpireTo,
            country: this.filter.country,
            visitorCardIdentifier: this.filter.visitorCardIdentifier,
            areaName: this.filter.areaName,
            employeeOrgID: this.filter.employeeOrgID,
            employeeName: this.filter.employeeName,
            employeeSurname: this.filter.employeeSurname,
            companyName: this.filter.companyName,
            companyVatin: this.filter.companyVatin,
            carPlate: this.filter.carPlate,
            carType: this.filter.carType,
            carColor: this.filter.carColor,
            usrDef1: this.filter.usrDef1,
            usrDef2: this.filter.usrDef2,
            usrDef3: this.filter.usrDef3,
            usrDef4: this.filter.usrDef4,
            template: this.selectedTemplate,
            format: this.dataExport,
          },
          responseType: responseTypeDef, // important
          timeout: axios.defaults.timeout * 10, // 10x default timeout for long running requests
        })
        .then((response) => {
          switch (this.dataExport) {
            case 'xlsx': {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', 'archive.xlsx');
              document.body.appendChild(link);
              link.click();
              this.exportLoader = false;
              break;
            }
            case 'print': {
              this.dialogPrintLoader = true;
              setTimeout(() => {
                this.dialogPrintLoader = false;
              }, 4500);
              const link = document.createElement('a');
              // TODO: Zistit preco sa UUID nechova ako JSON
              let rUUID = '';
              // Docasny workaround
              response.data.uuid === undefined ? (rUUID = JSON.parse(response.data).uuid) : (rUUID = response.data.uuid);
              link.href = `/api/v1/report/${rUUID}/pdf`;
              link.setAttribute('download', 'archiv.pdf');
              document.body.appendChild(link);
              link.click();
              this.exportLoader = false;
              break;
            }
            case 'xml': {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', 'archive.xml');
              document.body.appendChild(link);
              link.click();
              this.exportLoader = false;
              break;
            }
            case 'csv': {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', 'archive.csv');
              document.body.appendChild(link);
              link.click();
              this.exportLoader = false;
              break;
            }
            case 'yaml': {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', 'archive.yaml');
              document.body.appendChild(link);
              link.click();
              this.exportLoader = false;
              break;
            }
            case 'json': {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', 'archive.json');
              document.body.appendChild(link);
              link.click();
              this.exportLoader = false;
              break;
            }
            default: {
              this.totalItems = response.data.linesCount;
              for (const row of response.data.archive) {
                if (row.timeexit === null) {
                  row.timeexit = '';
                }
                if (row.expire === null) {
                  row.expire = '';
                }
                if (row.entryType === 'reader') {
                  row.entryType = 'čtečka';
                }
                if (row.entryType === 'manual') {
                  row.entryType = 'ručně';
                }
              }
              this.tableData = response.data.archive;
              this.loading = false;
              break;
            }
          }
          this.dataExport = '';
          this.dialogExport = false;
        })
        .catch((err) => {
          this.exportLoader = false;
          this.$store.dispatch('catchErrHandler', err);
        });
      this.loading = false;
    },
    loadListTemplates() {
      axios
        .get('/api/v1/template')
        .then((response) => {
          this.listTemplates = [];
          for (const item of response.data) {
            if (item.type === 'archive') {
              this.listTemplates.push(item);
            }
          }
          if (this.listTemplates.length > 0) {
            this.selectedTemplate = this.listTemplates[0].id;
          }
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    loadListCountries() {
      axios
        .get(`/api/v1/countries`)
        .then((response) => {
          for (const country of response.data) {
            country.comboBoxName = country.A3 + ' - ' + country.czShort;
          }
          this.listCountries = response.data;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    loadListbox(column: string) {
      axios
        .get(`/api/v1/archive/listbox/${column}`)
        .then((response) => {
          switch (column) {
            case 'name':
              this.listName = response.data;
              break;
            case 'surname':
              this.listSurname = response.data;
              break;
            case 'documentType':
              this.listDocumentType = response.data;
              break;
            case 'documentNo':
              this.listDocumentNo = response.data;
              break;
            case 'areaName':
              this.listAreaName = response.data;
              break;
            case 'employeeOrgID':
              this.listEmployeeOrgID = response.data;
              break;
            case 'employeeName':
              this.listEmployeeName = response.data;
              break;
            case 'employeeSurname':
              this.listEmployeeSurname = response.data;
              break;
            case 'workplaceNameEnter':
              this.listWorkplaceNameEnter = response.data;
              break;
            case 'workplaceNameExit':
              this.listWorkplaceNameExit = response.data;
              break;
            case 'companyName':
              this.listCompanyName = response.data;
              break;
            case 'companyVatin':
              this.listCompanyVatin = response.data;
              break;
            case 'carPlate':
              this.listCarPlate = response.data;
              break;
            case 'carType':
              this.listCarType = response.data;
              break;
            case 'carColor':
              this.listCarColor = response.data;
              break;
            case 'visitorCardIdentifier':
              this.listVisitorCardIdentifier = response.data;
              break;
            case 'usrDef1':
              this.listUsrDef1 = response.data;
              break;
            case 'usrDef2':
              this.listUsrDef2 = response.data;
              break;
            case 'usrDef3':
              this.listUsrDef3 = response.data;
              break;
            case 'usrDef4':
              this.listUsrDef4 = response.data;
              break;
            default:
              break;
          }
        })
        .catch((err) => {
          this.exportLoader = false;
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    formatTimeInObject(timeInObject: number) {
      let fTime = '';
      if (Math.trunc(timeInObject / 60) > 23) {
        fTime = Math.trunc(timeInObject / 60 / 24) + '/';
        timeInObject = timeInObject - Math.trunc(timeInObject / 60 / 24) * 24 * 60;
      }
      fTime = fTime + ('0' + Math.trunc(timeInObject / 60)).slice(-2) + ':' + ('0' + Math.trunc(timeInObject % 60)).slice(-2);
      return fTime;
    },
    clearFilter() {
      const getDefaults: any = this.$options;
      this.filter = { ...getDefaults.data().filter };
      var date = new Date();
      date.setDate(new Date().getDate() - 90);
      this.filter.dateEnterFrom = date.toISOString();
      this.dataLoad();
    },
    momentParse(inputDate: string) {
      return this.$moment(inputDate, this.$store.state.auth.df.date, true).isValid()
        ? this.$moment(inputDate, this.$store.state.auth.df.date).format('YYYY-MM-DD')
        : '';
    },
    formatDate(date: string, format: string) {
      return this.$moment(date).format(format);
    },
    formatDateTZ(date: string, timeZone: string, format: string) {
      return this.$moment(date).tz(timeZone).format(format);
    },
  },
});
</script>
